import { Component, inject } from '@angular/core';
import { MaterialTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MaterialTypeCreateDto,
  MaterialTypeDto,
  MaterialTypeExcelDownloadDto,
  MaterialTypeUpdateDto,
} from '../proxy/general/dtos/material-type';
import { MATERIALTYPE_CONFIG, MATERIALTYPE_FIELDS } from './material-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-material-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MaterialTypeService, ConfirmationService],
  templateUrl: './material-type.html',
  styleUrl: './material-type.scss',
})
export class MaterialType extends BaseCrudComponent<
  MaterialTypeDto,
  MaterialTypeCreateDto,
  MaterialTypeUpdateDto,
  MaterialTypeExcelDownloadDto
> {
  service = inject(MaterialTypeService);
  config = MATERIALTYPE_CONFIG;
  fields = MATERIALTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: MaterialTypeDto): MaterialTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MaterialType';
  }
}
